module.exports = __webpack_public_path__ + "static/media/proximanova-semibold.9603cb35.otf";